export class ENUM_TYPE {

    static readonly enumNextAppt:string =  'enumNextAppt';
    static readonly USER_FollowUpProcedure :string =  '00000850-1000-0000-0000-000000000003';
    static readonly USER_FollowUpPatient:string =  '00000850-1000-0000-0000-000000000004';
    static readonly USER_ReviewReport:string =  '00000850-1000-0000-0000-0000000000010';
    static readonly USER_FollowUpAR_Insurance:string =  '00000850-1000-0000-0000-0000000000011';
  }